module.exports = __webpack_public_path__ + "static/media/badgeIcon.bd94e678.png";